import { Component, Input } from '@angular/core';

@Component({
  selector: 'salonmonster-checkmark-loader',
  templateUrl: './smr-checkmark-loader.component.html',
  // ,
  styleUrls: ['./smr-checkmark-loader.component.scss']
})

export class SalonMonsterCheckMarkLoaderComponent {

  // source: https://codepen.io/scottloway/pen/zqoLyQ

  @Input() completed: boolean;
  
  constructor () {}
}
